import { useEffect } from 'react';
import useMenu from '../../framework/hooks/useMenuHook';

export default function NavigationMenu({ page }) {
    const menu = useMenu();

    useEffect(() => {
        window.initMenu();
    }, [menu]);

    return (
        <>
            {menu && (
                <>
                    {menu?.map((e, i) => (
                        <li key={i} className="nav-item">
                            {e.sub ? (
                                <>
                                    <a href="#" className="nav-link dropdown-toggle">
                                        {e.titel}
                                    </a>
                                    <ul className="dropdown-menu">
                                        {e.sub?.map((sub, i) => (
                                            <li key={i} className="nav-item">
                                                <a href={`/${sub.url_titel}`} className="nav-link">
                                                    {sub.titel}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <a href={`/${e.url_titel}`} className="nav-link">
                                    {e.titel}
                                </a>
                            )}
                        </li>
                    ))}
                </>
            )}
        </>
    );

    // return (
    //     <>
    //         <div className="header-area sticky-header header-area-left">
    //             <div className="header-layout">
    //                 <div className="logo light">
    //                     <a href="/" className="logo-1">
    //                         <img src="/assets/img/logo/logo.png" alt="logo" />
    //                     </a>
    //                     <a href="/" className="logo-2">
    //                         <img src="/assets/img/logo/logo-2.png" alt="logo" />
    //                     </a>
    //                 </div>
    //             </div>
    //         </div>
    //         <div className="header-area sticky-header header-area-right">
    //             <div className="header-layout">
    //                 <div className="menu-bar">
    //                     <div className="bar-wrap" onClick={toggle}>
    //                         <div className="bar-wrap-open">
    //                             <div className="bar-1" />
    //                             <div className="bar-2" />
    //                             <div className="bar-3" />
    //                         </div>
    //                         <div className="bar-wrap-close">
    //                             <div className="bar-1" />
    //                             <div className="bar-2" />
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //
    //         <div className="header-mobile-area">
    //             <div className="shape" />
    //             <div className="container">
    //                 <div className="row">
    //                     <div className="col-xl-6 col-lg-6 order-2 order-lg-1">
    //                         <div className="menu-info-wrapper">
    //                             <div className="social-icon-wrap">
    //                                 <p>Check onze socials</p>
    //                                 <div className="icon-wrap">
    //                                     <a href={extraFields?.socials_facebook}>
    //                                         <i className="fa-brands fa-facebook-f" />
    //                                     </a>
    //                                     <a href={extraFields?.socials_instagram}>
    //                                         <i className="fa-brands fa-instagram" />
    //                                     </a>
    //                                     <a href={extraFields?.socials_linkedin}>
    //                                         <i className="fa-brands fa-linkedin-in" />
    //                                     </a>
    //                                 </div>
    //                             </div>
    //                             <NieuwsbriefForm />
    //                         </div>
    //                     </div>
    //                     <div className="col-xl-6 col-lg-6 order-1 order-lg-1">
    //                         <div className="main-menu hover-effect">
    //                             <ul>
    //                                 {menu?.map((e, i) => (
    //                                     <li key={i}>
    //                                         <Link to={`/${e.url_titel}`}>{e.titel}</Link>
    //                                     </li>
    //                                 ))}
    //                             </ul>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     </>
    // );
}
